import { render, staticRenderFns } from "./POSStore.vue?vue&type=template&id=e0ae6194&"
import script from "./POSStore.vue?vue&type=script&lang=js&"
export * from "./POSStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports